
/**
 *
 * @param timerEnd
 * @param initialTimerDonations
 * @returns {import('@playlive/overlay-core').DonationWithTimerEffect}
 */
export const generateRandomEffect = (timerEnd, initialTimerDonations) => {
  const randomDonation =
    initialTimerDonations[Math.floor(Math.random() * initialTimerDonations.length)];

  const newTimerEnd = new Date(timerEnd);
  newTimerEnd.setTime(
    newTimerEnd.getTime() + randomDonation.timer_effect.timeDifference
  );

  return {
    donor_comment: randomDonation.donor_comment,
    donor_name: randomDonation.donor_name,
    campaign_id: randomDonation.campaign_id,
    completed_at: randomDonation.completed_at,
    cause_id: randomDonation.cause_id,
    timer_effect: randomDonation.timer_effect,
    timer_id: '1',
    amount: randomDonation.amount,
    id: Math.random().toString(36).substring(7),
    timer_end_date: newTimerEnd,
  };
};


